import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import React from "react";

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
        maxWidth: 320,
        fontFamily: "Yoga Sans",
        fontSize: "14px",
        letterSpacing: 0,
        lineHeight: "26px",
        fontWeight: 300,
        textAlign: "left",
    },
}));

const MortgageTooltip = (props: { children: React.ReactElement<any, any>; title: string }) => {
    const { title, children } = props;

    return (
        <StyledTooltip title={title} enterTouchDelay={0} describeChild={true}>
            <IconButton disableTouchRipple sx={{ padding: "0px" }}>
                {children}
            </IconButton>
        </StyledTooltip>
    );
};
export default MortgageTooltip;
